export class Context {
  public static forExistingTemplate(partnerId: string, templateId: string): Context {
    return new Context(partnerId, templateId, false);
  }

  public static forNewTemplate(partnerId: string): Context {
    return new Context(partnerId, null, false);
  }

  public static forNewTemplateReplacingLegacy(partnerId: string, legacyTemplateId: string): Context {
    return new Context(partnerId, legacyTemplateId, true);
  }

  private constructor(
    private readonly partnerId: string,
    private readonly templateId: string,
    private readonly replacingLegacy: boolean,
  ) {}

  isNew(): boolean {
    return this.templateId === null;
  }

  isReplacingLegacy(): boolean {
    return this.replacingLegacy;
  }

  getPartnerId(): string {
    return this.partnerId;
  }

  getExistingTemplateId(): string {
    if (this.templateId === null) {
      throw new Error('get called on context with no template ID');
    }
    return this.templateId;
  }
}
